import { render, staticRenderFns } from "./Tab.vue?vue&type=template&id=b17fcff2&scoped=true"
import script from "./Tab.vue?vue&type=script&lang=ts"
export * from "./Tab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b17fcff2",
  null
  
)

export default component.exports